import { ControlActionValue } from '@/lib/models/policy-model-v1/controls';
import { cloneDeep } from 'lodash';
import { ClassifierEntity } from '@/lib/models/policy-model-v1/classifier-controls';
import { FormHandle } from '@/hooks/use-form-handle.hook';
import { PolicyModelV1 } from '@/lib/models/policy-model-v1/policy-v1.model';
import { ClassifierModel } from '@/lib/models/classifier';

export interface ClassifierControlListProps {
  formHandle: FormHandle<PolicyModelV1>;
  orgPolicy?: PolicyModelV1;
  policy: PolicyModelV1;
  readonly: boolean;
  classifiers: ClassifierModel[];
  refetch: () => Promise<unknown>;
}

export const updateClassifierAction = (
  entities: ClassifierEntity[],
  classifierId: string,
  action: ControlActionValue
): ClassifierEntity[] => {
  const updated = cloneDeep(entities);
  const entityIndex = updated.findIndex(({ classifierId: id }) => id === classifierId);

  if (entityIndex > -1) {
    if (action) {
      updated[entityIndex].action = action;
    } else {
      updated.splice(entityIndex, 1);
    }
  } else if (action) {
    updated.push({ classifierId, action });
  }

  return updated;
};

// v1 only persists entries whose action diverges from the inherited org policy;
// matching entries are stripped so the policy stays a minimal diff against org.
export const filterUniqueEntities = (
  entities: ClassifierEntity[],
  orgEntities?: ClassifierEntity[]
): ClassifierEntity[] =>
  entities.filter(
    ({ classifierId, action }) =>
      action !== orgEntities?.find((entity) => entity.classifierId === classifierId)?.action
  );
